var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { useBackgroundContext } from '../BackgroundContext/index.js';
export const DIVIDER_PADDINGS = ['none', 'sm', 'md', 'lg'];
export const Divider = props => {
    const { children, className, padding = 'md' } = props, rest = __rest(props, ["children", "className", "padding"]);
    const { backgroundClsx, text400Clsx } = useBackgroundContext();
    return (React.createElement("div", Object.assign({ className: clsx([
            'relative',
            padding === 'none' && 'py-0',
            padding === 'sm' && 'py-2',
            padding === 'md' && 'py-4',
            padding === 'lg' && 'py-6',
            className,
        ]) }, rest),
        React.createElement("div", { className: "absolute inset-0 flex items-center", "aria-hidden": "true" },
            React.createElement("div", { className: "w-full border-t border-basicSurface-300/25" })),
        children && (React.createElement("div", { className: "relative flex justify-center" },
            React.createElement("span", { className: clsx('px-2', backgroundClsx, text400Clsx) }, children)))));
};
//# sourceMappingURL=Divider.js.map